// extracted by mini-css-extract-plugin
export default {"Box":"Table-module__Box--h4W6R","Box_1":"Table-module__Box_1--JrPYF","Box_2":"Table-module__Box_2--kJgvd","Box_3":"Table-module__Box_3--SP5mx","Box_4":"Table-module__Box_4--sB2q5"};